var exports = {
  "kL": "xb99ab02a--2c19f1--container",
  "Qs": "xb99ab02a--2c19f1--content",
  "Sl": "xb99ab02a--2c19f1--image",
  "DD": "xb99ab02a--2c19f1--title",
  "h_": "xb99ab02a--2c19f1--description",
};

module.exports = exports;
